module.exports = __webpack_public_path__ + "static/media/add.a7dc43f4.jpg";